import React, {useEffect} from "react";
import {useLocation} from "react-router-dom";

import { Header } from "@/components";

import { useAppDispatch } from "@/redux/store";
import { fetchContactsInfo } from "@/redux/contacts/asyncThunk";

import styles from "./Contacts.module.scss";
import { ContactsPropsType } from "./types";
import { ContactsInfo } from "./components/ContactsInfo/ContactsInfo";
import ourClubImage from "@/assets/img/ourClubImage.png";

export const Contacts: React.FC<ContactsPropsType> = ({ title }) => {
  const dispatch = useAppDispatch();

  const { pathname } = useLocation();
  
  useEffect(() => {
    dispatch(fetchContactsInfo());
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    document.documentElement.classList.add('contacts-page');
    document.body.classList.add('contacts-page');
    return () => {
      document.documentElement.classList.remove('contacts-page');
      document.body.classList.remove('contacts-page');
    };
  }, []);
  
  return (
    <>
      <Header title={title} />

      <main className={styles.main} style={{ backgroundImage: `url(${ourClubImage})` }}>
        <section className={`container ${styles.section}`}>
          <div className={styles.wrapper}>
            <div className={styles.contactsHeader}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="1" width="14" height="22" rx="2.5" stroke="#969696" strokeWidth="1.5"/>
                <line x1="9.5" y1="4" x2="14.5" y2="4" stroke="#969696" strokeWidth="1.2" strokeLinecap="round"/>
                <circle cx="12" cy="19.5" r="1.2" fill="#969696"/>
              </svg>
              <span>Контакты</span>
            </div>

            <ContactsInfo />
          </div>
        </section>
      </main>

    </>
  );
};
